// for employee information
export const DROPDOWN_DATA = "dropdown_data";
export const DROPDOWN_DATA_SUCCESS = "dropdown_data_success";
export const DROPDOWN_DATA_FAILURE = "dropdown_data_failure";
